import { PreferenceCenter } from "@ua/web-sdk/lib/remote-data/preference-center"
import * as React from "react"

import { PreferenceOperator } from "./EmailPreferenceCenter"
import ChannelSubscriptionItem from "./ChannelSubscriptionItem"
import ContactSubscriptionItem from "./ContactSubscriptionItem"
import ContactSubscriptionGroupItem from "./ContactSubscriptionGroupItem"

type Props = {
  items: PreferenceCenter["sections"][number]["items"]
  lastSection: boolean
} & PreferenceOperator

const Items: React.FC<Props> = ({ items, lastSection, ...rest }) => {
  if (!items) return null
  return (
    <ul>
      {items.map((item, index) => {
        // const itemType = item.type
        switch (item.type) {
          case "channel_subscription":
            return (
              <ChannelSubscriptionItem key={item.id} item={item} {...rest} />
            )
          case "contact_subscription":
            return (
              <ContactSubscriptionItem key={item.id} item={item} {...rest} />
            )
          case "contact_subscription_group":
            return (
              <ContactSubscriptionGroupItem
                key={item.id}
                item={item}
                showBreak={!lastSection || index < items.length - 1}
                {...rest}
              />
            )
          case "contact_management":
            return <></>
          case "alert":
            return <></>
          default: {
            // guard: if a new type is added, this will cause the typescript compiler to
            // yell
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const type: never = item
            return <></>
          }
        }
      })}
    </ul>
  )
}

export default Items
